module.exports = __webpack_public_path__ + "img/my.71e9353e.svg";